import React, { useState, useRef, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useNavigate, useLocation } from "react-router-dom";
import { Card } from "primereact/card";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Sidebar from "../Common/Sidebar";
import axios from "axios";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import Loader from "../Common/Loader";

export default function WebinarAnalysis() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showTranscription, setShowTranscription] = useState(false);
  const [showRecording, setShowRecording] = useState(false);
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const data = location.state?.data;
  const printContentRef = useRef<HTMLDivElement>(null);
  const [audioFile, setAudioFile] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleBackClick = () => {
    navigate("/webinar");
  };

  const handleTranscriptionClick = () => {
    setShowTranscription(true);
  };

  const handleViewRecordingClick = () => {
    setShowRecording(true);
  };

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename="webinar"
        onSidebarValueChanged={onSidebarValueChanged}
      />
      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div
          className={`${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
          <div>
            <h2 className="fw-bold">Webinar Analysis Dashboard </h2>
            <p className="text-muted"></p>
          </div>
          <div
            className="card py-4 px-4"
            style={{
              fontFamily: "'Segoe UI', 'Inter', sans-serif",
              fontSize: "14px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-4">
              <Button
                icon="fa fa-arrow-left"
                className="p-button curved-button primary-btn"
                onClick={handleBackClick}
              />
              <div className="d-flex gap-2">
                <Button
                  icon="fa fa-address-book"
                  label="See Transcription"
                  onClick={handleTranscriptionClick}
                  className="p-button curved-button btn-transcription"
                />
                <Button
                  icon="fa fa-light fa-video"
                  label="View Recording"
                  onClick={handleViewRecordingClick}
                  className="p-button curved-button primary-btn"
                />
              </div>
            </div>
            <div className="row g-2 d-flex mb-3 me-3 ">
              <div className="col-md-6">
                <div className="info-block shadow-hover p-4 rounded-4">
                  <h6 className="text-purple fw-semibold mb-3 title-heading">
                    Title
                  </h6>
                  <p className="text-dark m-2 body-content">
                     {data.title ? (data.title
                    ) : (
                     <span className="text-muted small">No title provided.</span>
                      )}
                  </p>
                </div>
              </div>
              <div className="col-md-6 mb-3 ">
                <div className="info-block shadow-hover p-4 rounded-4">
                  <h6 className="text-purple fw-semibold mb-3 title-heading">
                     Start Time
                  </h6>
                   <p className="text-dark m-2 body-content">
                     {data.start_time ? (data.start_time
                    ) : (
                     <span className="text-muted small">No time provided.</span>
                      )}
                  </p>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="info-block duration-card shadow-hover p-4 rounded-4">
                  <h6 className="text-purple fw-semibold mb-3 title-heading">
                   Duration
                    (Minutes)
                  </h6>
                  <p className="text-dark m-2 body-content">
                      {data.duration_minutes ? (
                     `${data.duration_minutes} minutes`
                      ) : (
                       <span className="text-muted small">No Duration time available.</span>
                      )}
                   </p>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="info-block host-email-card shadow-hover p-4 rounded-4">
                  <h6 className="text-purple fw-semibold mb-3 title-heading">
                   Host Email
                  </h6>
                 <p className="text-dark m-2 body-content">
                     {data.host_email ? (data.host_email
                    ) : (
                     <span className="text-muted small">No Host ID available.</span>
                      )}
                  </p>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="info-block participants-card shadow-hover p-4 rounded-4">
                  <h6 className="text-purple fw-semibold mb-3 title-heading">
                    Participants
                  </h6>
                  <div className="d-flex flex-wrap gap-2 m-2">
                    {(data.participants || "")
                      .split(",")
                      .map((participant: any, idx: any) => (
                        <span
                          key={idx}
                          className="participant-badge d-flex align-items-center"
                        >
                          <i className="fas fa-user-circle me-2"></i>
                          {participant.trim()}
                        </span>
                      ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="info-block chat-log-card shadow-hover p-4 rounded-4">
                  <h6 className="text-purple fw-semibold mb-3 title-heading">
                     Chat Log
                  </h6>
                  <p className="text-dark m-2 body-content">
                    {data.chat_log ? (data.chat_log
                     ) : (
                      <span className="text-muted small">No chat log found!!</span>
                     )}
                  </p>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="info-block dial-in-card shadow-hover p-4 rounded-4">
                  <h6 className="text-purple fw-semibold mb-3 title-heading">
                    Dialed In
                    Location
                  </h6>
                  <p className="text-dark m-2 body-content">
                    {data.dial_in_locations ? (data.dial_in_locations
                     ) : (
                      <span className="text-muted small">No Location found!!</span>
                     )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header="Transcription:"
        visible={showTranscription}
        style={{ width: "90%", maxWidth: "50%" }}
        onHide={() => setShowTranscription(false)}
        draggable={false}
        className="custom-dialog styled-dialog"
      >
        <div className="dialog-content-container">
          <div className="transcription-body">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : data.transcript ? (
              data.transcript.split("\n").map((line: string, index: number) => (
                <p key={index} style={{ marginBottom: "0.6rem" }}>
                  {line}
                </p>
              ))
            ) : (
              <p>No Transcription Found!!</p>
            )}
          </div>
        </div>
      </Dialog>
      <Dialog
        header="Recording:"
        visible={showRecording}
        style={{ width: "100%", maxWidth: "60%", height:"70%"}}
        onHide={() => setShowRecording(false)}
        draggable={false}
        className="custom-dialog styled-dialog"   
      >
        <div className="dialog-content-container">
          <div className="transcription-body">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : data.recording_url ? (
              <video
                src={data.recording_url}
                controls
                style={{ width: "100%", maxHeight: "450px", height:"90%"}}
              >
                Your browser does not support the video tag.
              </video>
            ) : (
              <p>No Recording Found!!</p>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
}
